"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Static = _interopRequireDefault(require("./Static"));
var _UserList = _interopRequireDefault(require("./UserList"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  "static": _Static["default"],
  userList: _UserList["default"]
};